(() => {
  const format = d =>
    d.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });

  const fix = () => {
    document.querySelectorAll("li[data-value] > span").forEach(span => {
      if (span.textContent.trim() !== "Invalid Date") return;

      // KEIN Datum vorhanden → nichts anzeigen statt kaputt
      span.textContent = "";
    });
  };

  fix();
  new MutationObserver(fix).observe(document.body, {
    childList: true,
    subtree: true
  });
})();